<div class="help-icon icon fill-grey" aria-label="help" (click)="goToDoc()" [inlineSVG]="'assets/ico/question-circle-solid.svg'"></div>